import { MotifFormField, MotifSearch } from '@ey-xd/motif-react'
import React from 'react'

const AdminPageHeader = (props: any) => {
    const {search, setSearch, title} = props;
    return (
        <div className="motif-row items-center mb-3">
            <div className="motif-col-sm-2">
                <p>{title}</p>
            </div>
            {search !== undefined && (
            <div className="motif-col-sm-2 flex gap-2 filterInputs">
                <MotifFormField className="!w-full !mb-0">
                    <MotifSearch
                        aria-label="Search"
                        id="states-search"
                        onChange={(e) => {
                            setSearch(e.target.value);
                        }}
                        onSelect={function Xo() { }}
                        placeholder="Search for..."
                        value={search}
                        maxLength={25}
                    />
                </MotifFormField>
            </div>
            )}
        </div>
    )
}

export default AdminPageHeader